import { render } from "./AlertsWithIcon.vue?vue&type=template&id=3a72a37d&ts=true"
import script from "./AlertsWithIcon.vue?vue&type=script&lang=ts"
export * from "./AlertsWithIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__